
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91_46_46_46slug_93I33gDCVz6R_l1rBxoEGxAj5B_24CvjtfV_45nrtT31xSEMeta } from "/home/userapp/pages/[...slug].vue?macro=true";
import { default as home_45detailjAQFgyVkMncGPRFvJclhAj94XCbBXhSoal0nvTNVMSUMeta } from "/home/userapp/pages/home-detail.vue?macro=true";
import { default as loginMV_455V2BE6ukdeg1yoFX7KbVVvHI3uK5BkFBtnTQind8Meta } from "/home/userapp/pages/account/login.vue?macro=true";
import { default as animal_45detailpBX6lFvSh025F6_smFTlJH6Stw2BVcLhifCmx2hwr7cMeta } from "/home/userapp/pages/animal-detail.vue?macro=true";
import { default as detailULItxZjmEHjAMkdcgBAzZ6AqBjQufD8Z65nJAYElHMsMeta } from "/home/userapp/pages/account/detail.vue?macro=true";
import { default as landing_45detailiEXu1IZ51C663jxz7mDtaCzjNhJt95aMQ2JiEa0KEfoMeta } from "/home/userapp/pages/landing-detail.vue?macro=true";
import { default as adminnrO3AwyJK2FvJjrez9Ump4y00rs7cERyVsBws5K5qeMMeta } from "/home/userapp/pages/redirect/admin.vue?macro=true";
import { default as shelter_45detail_45n5ICCkpjmKOt0VOIqlNCtklJ3pa0gpSlQr1CEZL4rIMeta } from "/home/userapp/pages/shelter-detail.vue?macro=true";
import { default as registerqUf3IVFCTwhn2WRiZGwo8FgRiRt8WX98obEHtAvTPgIMeta } from "/home/userapp/pages/account/register.vue?macro=true";
import { default as app_45health_45check4z8dQsaW7I7ba8OaHI0Ji15LQQUQkArkRV3BxcP3YJ0Meta } from "/home/userapp/pages/app-health-check.vue?macro=true";
import { default as accountclHHVmfeJ5nHyxphsCX_eLuVKl5YG_45i2gQVznDurlmYMeta } from "/home/userapp/pages/redirect/account.vue?macro=true";
import { default as verify_45emailG9tPwOu090L79tJYhtd3LbcIZ1YC_bhGwBK21NdRTcQMeta } from "/home/userapp/pages/account/verify-email.vue?macro=true";
import { default as password_45resetWGm4D43Vt0l81Yc591xxfDX0AAKacsAmY23vkOWP28UMeta } from "/home/userapp/pages/account/password-reset.vue?macro=true";
import { default as animal_45detailvtjJmS0fRO2D1UAUt6AUlMolfQo_45TvQh_GqUTK_ZarkMeta } from "/home/userapp/pages/redirect/animal-detail.vue?macro=true";
import { default as shelter_45detailSzwyuwCD8Vd_G0TfeKHs4Ckrt53Age3FEyS_452XB1pccMeta } from "/home/userapp/pages/redirect/shelter-detail.vue?macro=true";
import { default as resend_45activation_45email4CT26lP4CHT2UaRS4UmJtm6vvonwZH7ZjkPBXVdXvTgMeta } from "/home/userapp/pages/account/resend-activation-email.vue?macro=true";
export default [
  {
    name: "slug___nl",
    path: "/www/:departmentTypeSlug()/:siteSlug()/:pathMatch0()/:pathMatch()*~~/www/:pathMatch()*~~/ikzoekbaas/:pathMatch()*~~/mijndieriszoek/:pathMatch()*~~/inspectiedienst/:pathMatch()*",
    component: () => import("/home/userapp/pages/[...slug].vue")
  },
  {
    name: "home-detail___nl",
    path: "/www",
    component: () => import("/home/userapp/pages/home-detail.vue")
  },
  {
    name: "account-login___nl",
    path: "/ikzoekbaas/account/inloggen",
    component: () => import("/home/userapp/pages/account/login.vue")
  },
  {
    name: "animal-detail___nl",
    path: "/ikzoekbaas/asieldier/:categorySlug()/:id()-:name()~~/mijndieriszoek/:mdizCategory()/:categorySlug()/:id()-:name()",
    component: () => import("/home/userapp/pages/animal-detail.vue")
  },
  {
    name: "account-detail___nl",
    path: "/ikzoekbaas/account",
    component: () => import("/home/userapp/pages/account/detail.vue")
  },
  {
    name: "landing-detail___nl",
    path: "/www/:departmentTypeSlug()/:siteSlug()",
    component: () => import("/home/userapp/pages/landing-detail.vue")
  },
  {
    name: "redirect-admin___nl",
    path: "/all/admin/:slug?",
    component: () => import("/home/userapp/pages/redirect/admin.vue")
  },
  {
    name: "shelter-detail___nl",
    path: "/ikzoekbaas/afdelingen/:departmentTypeSlug()/:siteSlug()~~/mijndieriszoek/afdelingen/:departmentTypeSlug()/:siteSlug()",
    component: () => import("/home/userapp/pages/shelter-detail.vue")
  },
  {
    name: "account-register___nl",
    path: "/ikzoekbaas/account/registreren",
    component: () => import("/home/userapp/pages/account/register.vue")
  },
  {
    name: "app-health-check___nl",
    path: "/www/app-health-check",
    meta: app_45health_45check4z8dQsaW7I7ba8OaHI0Ji15LQQUQkArkRV3BxcP3YJ0Meta || {},
    component: () => import("/home/userapp/pages/app-health-check.vue")
  },
  {
    name: "redirect-account___nl",
    path: "/www/account/:slug?~~/mijndieriszoek/account/:slug?",
    component: () => import("/home/userapp/pages/redirect/account.vue")
  },
  {
    name: "account-verify-email___nl",
    path: "/ikzoekbaas/account/verify-email",
    component: () => import("/home/userapp/pages/account/verify-email.vue")
  },
  {
    name: "account-password-reset___nl",
    path: "/ikzoekbaas/account/wachtwoord-reset",
    component: () => import("/home/userapp/pages/account/password-reset.vue")
  },
  {
    name: "redirect-animal-detail___nl",
    path: "/www/:departmentTypeSlug()/:siteSlug()/animal-redirect/:animalType()/:category()/:idAndSlug()",
    component: () => import("/home/userapp/pages/redirect/animal-detail.vue")
  },
  {
    name: "redirect-shelter-detail___nl",
    path: "/www/:departmentTypeSlug()/:siteSlug()/detail-redirect",
    component: () => import("/home/userapp/pages/redirect/shelter-detail.vue")
  },
  {
    name: "account-resend-activation-email___nl",
    path: "/ikzoekbaas/account/resend-activation-email",
    component: () => import("/home/userapp/pages/account/resend-activation-email.vue")
  }
]